module.exports = __webpack_public_path__ + "a768e7de/img/pwrd-by-sourcery-black.bba9ba41.svg";